import { render, staticRenderFns } from "./ContratoRenovacao.vue?vue&type=template&id=7c96d7b5&"
import script from "./ContratoRenovacao.vue?vue&type=script&lang=js&"
export * from "./ContratoRenovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports